import { ICarrierApplicationStates } from 'types/graphqlTypes'

export const CARRIER_STATE_LABEL: Record<ICarrierApplicationStates, string> = {
  [ICarrierApplicationStates.new]: 'Fresh',
  [ICarrierApplicationStates.pending]: 'Pending',
  [ICarrierApplicationStates.application_submitted]: 'App. Submitted',
  [ICarrierApplicationStates.in_review]: 'In Review',
  [ICarrierApplicationStates.activated]: 'Active',
  [ICarrierApplicationStates.out_of_service]: 'Out of Service',
  [ICarrierApplicationStates.conditional]: 'Conditional',
  [ICarrierApplicationStates.cancelled]: 'Cancelled',
  [ICarrierApplicationStates.other]: 'Other',
  [ICarrierApplicationStates.probation]: 'Probation',
  [ICarrierApplicationStates.do_not_use]: 'Cannot Use',
  [ICarrierApplicationStates.expired_insurance]: 'Expired Ins.',
}

export type TCarrierStateLabels = typeof CARRIER_STATE_LABEL
